module.exports = __webpack_public_path__ + "img/4.3be57f66.png";